import { Component, AfterViewInit } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

export interface SessionExpiredPopupModel {
  title: string;
  message: string;
}

@Component({
  selector: 'src-session-expired-popup',
  templateUrl: './session-expired-popup.component.html',
})
export class SessionExpiredPopupComponent extends DialogComponent<SessionExpiredPopupModel, boolean>
  implements SessionExpiredPopupModel, AfterViewInit {
  title = 'Session Expired';
  message = 'Your session has expired.';
  closeBlocked = false;

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const modalTitle = document.getElementById('sessionExpiredTitle');
      if (modalTitle) {
        modalTitle.focus();
      }
    }, 100);
  }

  // Browsers only allow window.close() on tabs opened via window.open().
  // If the tab survives, keep the popup up and ask the user to close it.
  closeTab() {
    window.close();
    setTimeout(() => {
      if (!window.closed) {
        this.closeBlocked = true;
      }
    }, 300);
  }
}
